import { render, staticRenderFns } from "./garbageDelivery.vue?vue&type=template&id=81438e08"
import script from "./garbageDelivery.vue?vue&type=script&lang=js"
export * from "./garbageDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports